import request from "@/utils/request";

// 商品推荐主题列表，含商品详情
export function getGoodsRecommendList() {
  return request({
    url: '/product/recommend',
    method: 'GET'
  })
}

// 商品推荐主图
export function getGoodsRecommendImg() {
  return request({
    url: '/product/recommend/image',
    method: 'GET'
  })
}
